import React from 'react';
import classnames from 'classnames';
import { FiCheck } from 'react-icons/fi';

import { orderTypes, orderStatus } from '../constants';

import css from './OrderLifecycle.css';

const buildSteps = (keys, labelFn, status) => {
  if (status == 'cancelled') {
    return [{ key: 'cancelled', label: 'Cancelado', done: true, current: true }];
  }
  let current = -1;
  const filtered = keys.filter((k) => k != 'cancelled');
  filtered.forEach((k, i) => {
    if (status == k) current = i;
  });
  return filtered.map((k, i) => ({
    key: k,
    label: labelFn(k),
    done: status != null && current >= 0 && i < current,
    current: status == k,
  }));
};

export default ({ orderType = 'delivery', status, error }) => {
  error = status == 'cancelled' ? true : error;

  let title;
  let steps;
  if (orderType == 'delivery' || orderType == 'custody') {
    title = 'Envío';
    steps = buildSteps(orderStatus.delivery.keys, orderStatus.delivery, status);
  } else if (orderType == 'reversal') {
    title = status == 'completed' ? 'Envío revocado' : 'Envío en revocación';
    steps = buildSteps(orderStatus.reversal.keys, orderStatus.reversal, status);
  } else if (orderType == 'return') {
    title = orderTypes('return');
    steps = buildSteps(orderStatus.return.keys, orderStatus.return, status);
  } else {
    steps = [];
  }

  const currentIndex = steps.findIndex((s) => s.current);
  const stepCount = steps.length;
  const halfStep = stepCount > 0 ? 100 / stepCount / 2 : 0;
  const trackWidth = stepCount > 1 ? 100 - halfStep * 2 : 0;
  const fraction =
    status == 'cancelled' ? 1 : stepCount > 1 && currentIndex > 0 ? currentIndex / (stepCount - 1) : 0;
  const progressWidth = fraction * trackWidth;

  return (
    <div className={css.root}>
      <div className={classnames(css.tracker, { [css.error]: error })}>
        <h3 className={css.kicker}>{title}</h3>
        <div className={css.steps}>
          <div className={css.track} style={{ left: `${halfStep}%`, width: `${trackWidth}%` }} />
          <div className={css.progress} style={{ left: `${halfStep}%`, width: `${progressWidth}%` }} />
          {steps.map((s) => (
            <div key={s.key} className={classnames(css.step, { [css.done]: s.done, [css.current]: s.current })}>
              <span className={css.stepDot}>{s.done && !s.current ? <FiCheck size={11} /> : null}</span>
              <span className={css.stepLabel}>{s.label}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
